export default __webpack_public_path__ + "media/images/svg/full-logo-001bc72e3097c22b4c6885339de20feb.svg";